/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import { CTA, Tabs, Text } from '../../../ui/atoms';
import { LiveEventsBox, Title } from './style';
import { Container } from '../../../ui/gridSystem';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { COURSE_CATEGORIES_GET } from '../../redux/actions/courselist';
import {
  TUTOR_COURSE_LIST_GET,
  TUTOR_EVENT_LIST_GET,
} from '../../redux/actions/tutorCourseList';
import routes from '../../../routes';
import CourseList from './CourseList';
import EventList from './EventList';

const defaultTabs = [
  { value: 'courses', label: 'Corsi' },
  { value: 'events', label: 'Eventi' },
];

const TutorCourseList = ({
  mediaIsPhone,
  categories,
  coursePager,
  eventPager,
  isTutor,
  getCategories,
  getCourseList,
  getEventList,
}) => {
  const navigate = useNavigate();
  // tabs
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(defaultTabs[0]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (categories?.length <= 0) getCategories();
    getCourseList();
    getEventList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const newTabs = [...defaultTabs];
    newTabs[0].items = coursePager?.total_items ?? 0;
    newTabs[1].items = eventPager?.total_items ?? 0;
    setTabs(newTabs);
  }, [coursePager?.total_items, eventPager?.total_items]);

  return (
    <Container>
      <Title>
        <Text type="h1">Gestione percorsi formativi</Text>
        {isTutor && (
          <>
            {activeTab?.value === 'events' ? (
              <LiveEventsBox>
                <Text type="b3">
                  Monitora e gestisci gli eventi dal vivo nell’apposita sezione.
                </Text>
                <CTA
                  btnText="GESTISCI EVENTI DAL VIVO"
                  icon="settings-04"
                  type="tertiary"
                  onClick={() => navigate(routes.liveEventList.path)}
                  bottomRight={mediaIsPhone}
                />
              </LiveEventsBox>
            ) : (
              <CTA
                type="tertiary"
                btnText="Crea nuovo percorso"
                onClick={() => navigate(routes.chooseCourseType.path)}
                icon="plus"
              />
            )}
          </>
        )}
        <Text type="b3" className="subtitle">
          Sezione dedicata alla gestione dei percorsi formativi creati.
        </Text>
      </Title>
      <Text type="h2" mb={24}>
        Percorsi formativi creati
      </Text>
      <Tabs
        tabs={tabs}
        selected={activeTab}
        onChange={(tab) => {
          setActiveTab(tab);
        }}
      />
      <div
        style={{ display: activeTab?.value === 'courses' ? 'block' : 'none' }}
      >
        <CourseList active={activeTab?.value === 'courses'} />
      </div>
      <div
        style={{ display: activeTab?.value === 'events' ? 'block' : 'none' }}
      >
        <EventList active={activeTab?.value === 'events'} />
      </div>
    </Container>
  );
};

TutorCourseList.propTypes = {
  mediaIsPhone: PropTypes.bool,
  // HOC (connect, state)
  categories: PropTypes.array,
  coursePager: PropTypes.object,
  eventPager: PropTypes.object,
  isTutor: PropTypes.bool,
  // HOC (connect, dispatch)
  getCategories: PropTypes.func.isRequired,
  getCourseList: PropTypes.func.isRequired,
  getEventList: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const {
        courseList: { pager: coursePager },
        eventList: { pager: eventPager },
      } = state.tutorCourseList;
      const { categories } = state.courselist;
      const { isTutor } = state.user;
      return { categories, coursePager, eventPager, isTutor };
    },
    (dispatch) => ({
      getCategories: (filters) =>
        dispatch({ type: COURSE_CATEGORIES_GET._REQUEST, filters }),
      getCourseList: (filters = {}) =>
        dispatch({ type: TUTOR_COURSE_LIST_GET._REQUEST, filters }),
      getEventList: (filters = {}) =>
        dispatch({ type: TUTOR_EVENT_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(TutorCourseList);
